import * as React from 'react';
import { GroupsConsumer } from './GroupsContext';
import { ApiTypes } from '@wix/social-groups-api';

export interface WithGroupsProps {
  groups: ApiTypes.v1.GroupResponse[];
  isGroupCreating?: boolean;
}

const withGroups = <P extends object>(
  WrappedComponent: React.ComponentType<P>,
) =>
  class WithGroups extends React.Component<P & WithGroupsProps> {
    render() {
      return (
        <GroupsConsumer>
          {data => <WrappedComponent {...data} {...this.props} />}
        </GroupsConsumer>
      );
    }
  };

export default withGroups;
